
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/membership-regulations",
      function () {
        return require("private-next-pages/company/membership-regulations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/membership-regulations"])
      });
    }
  